import { render, staticRenderFns } from "./BookmarkedItems.vue?vue&type=template&id=66940c36"
import script from "./BookmarkedItems.vue?vue&type=script&lang=js"
export * from "./BookmarkedItems.vue?vue&type=script&lang=js"
import style0 from "./BookmarkedItems.vue?vue&type=style&index=0&id=66940c36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports